exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".body-fcef0aae{padding:30px 50px;display:flex;flex-flow:column;align-items:center}.body-fcef0aae div{padding-top:20px;font-size:15px;font-weight:22px}.footer-6658dece{display:flex;justify-content:flex-end}.footer-6658dece a.specificity-5bc4de0f{max-width:144px;padding:12px 20px}.footer-6658dece a.leftLink-1d203c46{max-width:120px;padding:12px 15px}.footer-6658dece a.middleLink-b89dfa3d{padding:12px 30px 12px 15px;max-width:155px}\n", ""]);

// Exports
exports.locals = {
	"body": "body-fcef0aae",
	"footer": "footer-6658dece",
	"specificity": "specificity-5bc4de0f",
	"leftLink": "leftLink-1d203c46",
	"middleLink": "middleLink-b89dfa3d"
};